{
    "NavigationNext": "Nächste",
    "NavigationPrevious": "Vorherige",
    "ApplicationUservoice": "https:\/\/akixi.uservoice.com",
    "ApplicationDefaultDirectory": "\/CCS\/Stile\/Bilder\/Akixi2019\/",
    "NAME": "LanguageGeneral"
}